import React from "react";
import { Navigate } from "react-router-dom";

const StkGeneralsComponent = React.lazy(
  () =>
    import("../../../../../components/stk-catalogues/components/general/page"),
);

export const catalogueRoutes = [
  {
    path: "general",
    element: <StkGeneralsComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/control/catalogues/general" />,
  },
];
